var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BaseDataList',{ref:"dataList",attrs:{"items":_vm.purchasedAccProducts,"service":_vm.fetchPurchasedAccProducts},scopedSlots:_vm._u([{key:"header",fn:function(){return [_c('PurchasedAccProductListHeader')]},proxy:true},{key:"default",fn:function({ item }){return [_c('PurchasedAccProductListItem',{attrs:{"acc-product":item}})]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }